import { Card, CardContent, TextField } from "@material-ui/core";
import CardTitle from "@saleor/components/CardTitle";
import FormSpacer from "@saleor/components/FormSpacer";
import React from "react";
import { useIntl } from "react-intl";

import { PageheaderPageFormData } from "../PageheaderPage";

export interface PageheaderColorProps {
  mainColor: string;
  secondaryColor: string;
  disabled: boolean;
  onChange: (event: any) => void;
}
const PageheaderColor: React.FC<PageheaderColorProps> = ({
  mainColor,
  secondaryColor,
  disabled,
  onChange
}) => {
  const intl = useIntl();

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Theme Color",
          description: "Theme Color"
        })}
      />
      <CardContent>
        <TextField
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Border Color",
            description: "Border Color"
          })}
          name={"mainColor" as keyof PageheaderPageFormData}
          fullWidth
          value={mainColor}
          onChange={onChange}
        />
        <FormSpacer />
        <TextField
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Background Color",
            description: "Background Color"
          })}
          name={"secondaryColor" as keyof PageheaderPageFormData}
          fullWidth
          value={secondaryColor}
          onChange={onChange}
        />
        <FormSpacer />
        <div
          style={{
            borderColor: mainColor,
            borderWidth: 2,
            borderStyle: "solid",
            background: secondaryColor,
            width: "120px",
            height: "30px",
            marginRight: "20px",
            textAlign: "center",
            paddingTop: "5px"
          }}
        />
      </CardContent>
    </Card>
  );
};
export default PageheaderColor;
